import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId70205: SiteIdOverrideConfig = {
  global: {
    heroImageSrc:
      "https://thumbnails.trvl-media.com/6P3zpFxydQHeILfbqQR05Lu8nZw=/1320x0/a.travel-assets.com/travel-assets-manager/a41c1064-9ab5-460b-8b85-00c02bf16082/canadaunited.jpeg",
  },
  car: {
    disableVendorCouponCode: true,
    iHaveDiscount: "wizard.car.having.brand.title",
    vendors: {
      AC: {
        includeInDropdown: false,
      },
      AD: {
        includeInDropdown: false,
      },
      EY: {
        includeInDropdown: false,
      },
      EP: {
        includeInDropdown: false,
      },
      FX: {
        includeInDropdown: false,
      },
      MW: {
        includeInDropdown: false,
      },
      NU: {
        includeInDropdown: false,
      },
      ZA: {
        includeInDropdown: false,
      },
      RO: {
        includeInDropdown: false,
      },
      SX: {
        includeInDropdown: false,
      },
      SV: {
        includeInDropdown: false,
      },
      SC: {
        includeInDropdown: false,
      },
    },
  },
};
